/**
 * Middleware used to prevent access to main application form until the event questionnaire is complete
 */
import { ConnectedRouter } from '@jauntin/react-ui';
import RouteParser from '../Helpers/RouteParser';

const ApplicationPageMiddleware = (store) => (next) => (action) => {
  if (action.type === ConnectedRouter.LOCATION_CHANGE) {
    const route = action.payload.location.pathname.toLowerCase();
    const params = action.payload.location.search.toLowerCase();
    const routeParser = RouteParser.create(route, params);
    const { eventType } = routeParser._routeParts;
    const { queryParams } = routeParser._routeParts;
    const eventSecondaryCheck =
      store.getState().formPage.eventSelectSecondary.valid;
    if (routeParser.isApplicationPage() && !eventSecondaryCheck) {
      return store.dispatch(
        ConnectedRouter.push(`/${eventType}${queryParams}`),
      );
    }
  }
  return next(action);
};

export default ApplicationPageMiddleware;
